import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { TTProtection } from "../../TTProtection";
import { toKeyValuePairArray } from "../../../../Utils/maps";
import { relationClassificationAsString } from "../../../RelationClassification";
import { plantTypeAsStringForAffectedPartDestination } from "../../../../Plants/PlantType";
import { EnumMultiSelect } from "./MultiSelectMenues/EnumMultiSelect";
import { TTProtectionFiltersPlantGsdbMultiSelect } from "./TTProtectionFiltersPlantGsdbMultiSelect";
import { TTProtectionFiltersIeoPlantsMultiSelect } from "./TTProtectionFiltersIeoPlantsMultiSelect";

export const ScopeDefinitionFilters = () => {
  const { control } = useFormContext<TTProtection>();

  return (
    <BorderedFormGrid subformName="Scope Definition">
      <Grid item xs={12}>
        <EnumMultiSelect
          control={control}
          name="TtProtectionFilters.SpdrClassifications"
          label="SPDR Classification"
          options={toKeyValuePairArray(relationClassificationAsString)}
        />
      </Grid>
      <Grid item xs={12}>
        <EnumMultiSelect
          control={control}
          name="TtProtectionFilters.PlantTypes"
          label="Part Destination"
          options={toKeyValuePairArray(plantTypeAsStringForAffectedPartDestination)}
        />
      </Grid>
      <Grid item xs={12}>
        <TTProtectionFiltersPlantGsdbMultiSelect
          control={control}
          name="TtProtectionFilters.PlantGsdbs"
          nameToSubscribeTo="TtProtectionFilters.PlantTypes"
        />
      </Grid>
      <Grid item xs={12}>
        <TTProtectionFiltersIeoPlantsMultiSelect
          control={control}
          name="TtProtectionFilters.IeoPlantGsdbs"
          nameToSubscribeTo="TtProtectionFilters.PlantGsdbs"
        />
      </Grid>
    </BorderedFormGrid>
  );
};
